import { Flex, Link, Svg } from '@stars-ecom/shared-atoms-ui'
import React, { memo } from 'react'

const ByConcernPushThumbnail = (props) => {
  const { byConcernPush } = props

  return (
    <Flex direction="column" align="center" borderRadius="14px" justifyContent="center" minW="150px" w={{ base: '150px', md: '175px' }} h={{ base: '150px', md: '175px' }} bg={byConcernPush?.backgroundColor} transition="transform 0.2s ease-in-out" _hover={{ transform: 'scale(1.1)'}}>
      <Link to={byConcernPush?.link} >
        <Flex direction="column">
          <Flex m="auto" justifyContent="center" width={{ base: '80px', md: '100px' }} height={{ base: '80px', md: '100px' }}>
            <Svg color={byConcernPush?.textColor} data={byConcernPush?.picto} width="100%" height="100%"/>
          </Flex>
          <Flex
            fontSize={{ base: '16px', md: '18px' }}
            fontFamily="PT SANS"
            fontWeight="700"
            textTransform="uppercase"
            alignSelf="center"
            textAlign="center"
            lineHeight={{ base: '16px', md: '18px' }}
            textColor={byConcernPush?.textColor}
            mt="16px"
            dangerouslySetInnerHTML={{ __html: byConcernPush?.label }}></Flex>
        </Flex>
      </Link>
    </Flex>
  )
}

export default memo(ByConcernPushThumbnail)
